// Pagination
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginationList from './PaginationList';
import { getPager } from '../../reducers/reducer-functions';

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.defaultProps = {
      initialPage: 1,
      pageSize: 12,
    };

    this.state = {
      pager: {},
    };

    this.setPage = this.setPage.bind(this);
  }

  componentDidMount() {
    // set page if items array isn't empty
    if (this.props.items && this.props.items.length) {
      this.setPage(this.props.initialPage);
    }
  }

  componentDidUpdate(prevProps) {
    // reset page if items array has changed
    if (this.props.items !== prevProps.items) {
      this.setPage(this.props.initialPage);
    }
  }

  setPage(page) {
    const { items, pageSize } = this.props;

    if (page < 1 || page > this.state.pager.totalPages) {
      return;
    }

    // get new pager object for specified page
    const pager = getPager(items.length, page, pageSize);

    // get new page of mediaItems from mediaItems array
    const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

    // update state
    this.setState({ pager });

    this.props.onChangePage(pageOfItems);
  }

  render() {
    if (!this.state.pager.pages || this.state.pager.pages.length <= 1) {
      return null;
    }

    return (
      <PaginationList pager={this.state.pager} setPage={this.setPage} />
    );
  }
}

Pagination.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  onChangePage: PropTypes.func.isRequired,
  initialPage: PropTypes.number,
  pageSize: PropTypes.number,
};

export default Pagination;
